:host {
  --header-padding: var(--header-padding-medium);
  --header-padding-small: var(--spacing-scale-base);
  --header-padding-medium: var(--spacing-scale-2x);
  --header-padding-large: var(--spacing-scale-3x);

  --header-logo-size: var(--header-logo-medium);
  --header-logo-small: 16px;
  --header-logo-medium: 24px;
  --header-logo-large: 40px;

  --header-title-size: var(--font-size-scale-base);

  --header-subtitle-size: var(--font-size-scale-down-01);

  --header-logo-desktop-width: 120px;
  --header-logo-desktop-height: 48px;
  --header-logo-compact: 60px;
  --header-logo-compact-height: 32px;
  --header-logo-mobile-width: 80px;
  --header-logo-mobile-height: 40px;

  display: block;
  width: 100%;
}

:host([is-sticky]) {
  transition: all 0.15s ease;
  position: sticky;
  top: 0;
  z-index: var(--z-index-layer-2);
}

.br-header {
  display: flex;
  flex-direction: column;
  background: var(--background);
  box-shadow: var(--surface-shadow-sm);
  padding: var(--header-padding) 0;
  position: relative;

  br-divider {
    &::part(hr) {
      margin: 0 var(--spacing-scale-base);
    }
  }

  &.compact {
    --header-padding: var(--header-padding-small);

    .header-bottom-left {
      flex: 0 0 auto;
    }
  }

  &.small {
    --header-padding: var(--header-padding-small);
  }

  &.large {
    --header-padding: var(--header-padding-large);
  }

  .header-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .header-top-left,
    .header-top-right {
      display: flex;
    }

    .header-top-left {
      flex: 0 0 auto;

      .header-logo {
        align-self: center;
      }

      .header-signature {
        align-self: center;
        font-weight: 500;
        overflow: hidden;
      }
    }

    .header-top-right {
      flex: 1 0 auto;
      justify-content: flex-end;

      .header-links {
        align-self: center;
      }

      .header-functions {
        align-self: center;
      }

      .header-search-icon {
        align-self: center;
      }

      .header-access {
        align-self: center;
      }
    }
  }

  .header-bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: var(--header-padding-small);

    .header-bottom-left {
      display: flex;

      .header-caption-wrapper {
        margin-left: var(--spacing-scale-2x);
      }

      .header-caption {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: var(--header-title-size);
        margin-top: 2px;
      }

      .header-subcaption {
        font-size: var(--header-subtitle-size);
        font-weight: 500;
        margin-top: var(--spacing-scale-half);
      }
    }

    .header-bottom-right {
      display: none;
      min-width: 268px;
      flex: 0 0 auto;

      &.is-active {
        display: flex;
      }
    }
  }

  .header-access {
    margin-left: var(--spacing-scale-3x);
  }

  .header-menu-trigger {
    margin-right: var(--spacing-scale-half);
  }

  .header-search {
    &[is-active] {
      align-items: center;
      background: var(--background);
      inset: 0;
      display: flex;
      padding: 0 var(--spacing-scale-2x);
      position: absolute;

      ::slotted(br-input) {
        width: 100%;
      }

      .search-close {
        margin-left: var(--spacing-scale-base);
      }
    }
  }
}

@media (width >= 576px) {
  .br-header {
    .header-top {
      .header-top-right {
        position: relative;
      }
    }

    .header-bottom {
      .header-bottom-left {
        .header-caption {
          --header-title-size: var(--font-size-scale-up-02);

          margin-top: 0;
        }

        .header-subcaption {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    &.compact {
      .container-lg {
        position: relative;
      }

      .header-top {
        display: block;
      }

      .header-top-left {
        float: left;
      }

      .header-top-right {
        float: right;
        margin-top: var(--spacing-scale-2xh);
        position: relative;
      }

      .header-bottom {
        clear: left;
      }
    }
  }
}

@media (width >= 1280px) {
  .br-header {
    .header-bottom {
      .header-bottom-right {
        display: flex;
      }

      ::slotted([slot="search"]) {
        width: 385px;
      }
    }
  }
}
